<template>
  <el-col :lg="24">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>{{ $t("faturas") }}</span>
        <el-form style="float: right; padding: 3px 0" :inline="true">
          <el-button type="primary" @click="go('invoice.add')">Gerar Faturas</el-button>
          <el-button type="info" @click="go('invoice.single')">Faturas Avulsa</el-button>
        </el-form>
      </div>
      <el-table :data="tableDataList" ref="tableInvoice" style="width: 100%">
        <el-table-column type="selection" width="60"></el-table-column>
        <el-table-column sortable prop="customer" :label="$t('cliente')">
          <template slot-scope="scope">
            {{ scope.row.companyname }}
          </template>
        </el-table-column>
        <el-table-column prop="value" :label="$t('valor')">
          <template slot-scope="scope">
            {{
              scope.row.value
                | currency("R$ ", 2, {
                  thousandsSeparator: ".",
                  decimalSeparator: ",",
                })
            }}
          </template>
        </el-table-column>
        <el-table-column prop="services" :label="$t('valor-servico')">
          <template slot-scope="scope">
            {{
              scope.row.services
                | currency("R$ ", 2, {
                  thousandsSeparator: ".",
                  decimalSeparator: ",",
                })
            }}
          </template>
        </el-table-column>
        <el-table-column prop="price" :label="$t('valor-tabela')">
          <template slot-scope="scope">
            {{
              scope.row.price
                | currency("R$ ", 2, {
                  thousandsSeparator: ".",
                  decimalSeparator: ",",
                })
            }}
          </template>
        </el-table-column>
        <el-table-column prop="discount" :label="$t('desconto')">
          <template slot-scope="scope">
            {{
              scope.row.discount
                | currency("R$ ", 2, {
                  thousandsSeparator: ".",
                  decimalSeparator: ",",
                })
            }}
          </template>
        </el-table-column>
        <el-table-column prop="total" :label="$t('valor-total')">
          <template slot-scope="scope">
            {{
              scope.row.total
                | currency("R$ ", 2, {
                  thousandsSeparator: ".",
                  decimalSeparator: ",",
                })
            }}
          </template>
        </el-table-column>
        <el-table-column prop="createdAt" width="110" :label="$t('data')" sortable>
          <template slot-scope="scope">
            {{ scope.row.createdAt | formatDate }}
          </template>
        </el-table-column>
        <el-table-column width="220">
          <template slot-scope="scope">
            <el-button
              type="danger"
              title="Eliminar"
              icon="el-icon-delete"
              @click="remove(scope.row.id)"
              circle
            ></el-button>
            <el-button
              type="success"
              title="Baixar"
              icon="el-icon-check"
              @click="payment(scope.row.id)"
              circle
            ></el-button>
            <el-button
              type="primary"
              title="Postagens"
              icon="el-icon-printer"
              @click="exportPrepost(scope.row.id)"
              circle
            ></el-button>
            <el-button type="info" title="Boleto" icon="el-icon-download" @click="pdf(scope.row.id)" circle></el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="bottom clearfix">
        <el-row :gutter="5">
          <el-col :lg="12">
            <el-button type="info" @click="go('invoice.add')">Gerar Faturas</el-button>
            <el-button type="info" @click="cnab()">CNAB</el-button>
          </el-col>
          <el-col :lg="3" style="margin-top: 2px; float: right">
            <el-dropdown>
              <el-button>
                Exportar
                <i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>
                  <download-excel :fields="json_fields" name="faturas.xls" :data="excel">XLS</download-excel>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-col>
        </el-row>
      </div>
    </el-card>
  </el-col>
</template>
<script>
import { BilletService } from "@/services/customers/billet.services";
import { InvoiceServices } from "@/services/customers/invoice.services";
import moment from "moment";
import "moment/locale/pt-br";

export default {
  name: "CockpitInvoiceList",
  computed: {
    tableDataList() {
      const vm = this;
      return vm.tableData;
    },
    excel() {
      const vm = this;
      if (vm.$refs.tableInvoice && vm.$refs.tableInvoice.selection.length > 0) {
        return vm.$refs.tableInvoice.selection;
      }
      return vm.tableData;
    },
  },
  props: {
    range: Array,
    customer: String,
    service: String,
  },
  methods: {
    payment(id) {
      const vm = this;
      this.$confirm("Confirma o pagamento dessa fatura?", "Aviso", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancelar",
        type: "Aviso",
        center: true,
      }).then(() => {
        const loading = vm.$loading(vm.$options.loading);
        BilletService.payment(id)
          .then((response) => {
            this.$message({
              type: "success",
              duration: 5000,
              message: "Fatura marcada como paga com sucesso!",
            });
          })
          .catch((error) => {
            this.$message({
              type: "error",
              message: error,
              duration: 5000,
            });
          })
          .finally(() => loading.close());
      });
    },
    remove(id) {
      const vm = this;
      this.$confirm("Confirma eliminação da fatura?", "Aviso", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancelar",
        type: "Aviso",
        center: true,
      }).then(() => {
        const loading = vm.$loading(vm.$options.loading);
        BilletService.delete(id)
          .then((response) => {
            vm.fetchRecords();
            this.$message({
              type: "success",
              duration: 5000,
              message: "Fatura eliminada com sucesso!",
            });
          })
          .catch((error) => {
            this.$message({
              type: "error",
              message: error,
              duration: 5000,
            });
          })
          .finally(() => loading.close());
      });
    },
    exportPrepost(id) {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      InvoiceServices.export(id)
        .then((response) => {
          var downloadLink = document.createElement("a");
          downloadLink.href = response;
          downloadLink.download = `invoice.${id}.csv`;
          document.body.appendChild(downloadLink);
          downloadLink.click();
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
            duration: 5000,
          });
        })
        .finally(() => loading.close());
    },
    pdf(id) {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      BilletService.pdf(id)
        .then((response) => {
          var downloadLink = document.createElement("a");
          downloadLink.href = response;
          downloadLink.download = `${id}.pdf`;
          document.body.appendChild(downloadLink);
          downloadLink.click();
        })
        .catch((error) => {
          vm.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },
    go(page) {
      var vm = this;
      vm.$router.replace({
        name: page,
      });
    },
    cnab() {
      const vm = this;
      if (vm.$refs.tableInvoice.selection.length === 0) {
        return vm.$message({
          type: "error",
          message: "Selecione as faturas para gerar o arquivo CNAB!",
        });
      }
      const loading = vm.$loading(vm.$options.loading);
      InvoiceServices.cnab(vm.$refs.tableInvoice.selection)
        .then((response) => {
          var arr = response.content.data;
          var byteArray = new Uint8Array(arr);
          var a = window.document.createElement("a");

          a.href = window.URL.createObjectURL(new Blob([byteArray], { type: "application/octet-stream" }));
          a.download = response.name;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },
    fetchRecords() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      const s = moment(vm.range[0]);
      const f = moment(vm.range[1]);
      InvoiceServices.filter({
        customer: vm.customer,
        startedAt: s.format("YYYY-MM-DD"),
        finishedAt: f.format("YYYY-MM-DD"),
      })
        .then((response) => {
          vm.tableData = response.records;
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },
  },
  mounted() {
    const vm = this;
    vm.fetchRecords();
  },
  data() {
    return {
      filter: "",
      drawer: false,
      innerDrawer: false,
      tableData: [],
      json_fields: {
        Cliente: {
          field: "companyname",
        },
        Valor: {
          field: "value",
          callback: (value) => {
            return `R$ ${(+value).toFixed(2)}`;
          },
        },
        "Valor Serviço": {
          field: "services",
          callback: (value) => {
            return `R$ ${(+value).toFixed(2)}`;
          },
        },
        "Valor Tabela": {
          field: "price",
          callback: (value) => {
            return `R$ ${(+value).toFixed(2)}`;
          },
        },
        "Valor Desconto": {
          field: "discount",
          callback: (value) => {
            return `R$ ${(+value).toFixed(2)}`;
          },
        },
        "Valor Total": {
          field: "total",
          callback: (value) => {
            return `R$ ${(+value).toFixed(2)}`;
          },
        },
        "Data Fatura": {
          field: "createdAt",
          callback: (value) => {
            return moment(String(value)).format("DD/MM/YYYY");
          },
        },
      },
      ruleForm: {
        start: "",
      },
    };
  },
};
</script>
<style>
.right {
  float: right;
}
.label {
  font-weight: bold;
}
</style>
